// filepath: d:\Examflip-repo\ExamFlip\src\frontend\src\services\index.js
/**
 * Services Index
 * Export all services to provide a single import point
 */

import categoryService from './categoryService';
import categoryGroupService from './categoryGroupService';
import examTypeService from './examTypeService';
import examService from './examService';
import feedbackService from './feedbackService';
import savedQuestionsService from './savedQuestionsService';
import aiService from './aiService';
import answerService from './answerService';
// Use our fixed version of the question service
import questionService from './questionServiceFix';
import questionFormatService from './questionFormatService';
import userFolderService from './userFolderService';

// Import new refactored services
import * as themeService from './themeService';
import * as sessionService from './sessionService';

// Import authentication services
import authService from './authService';
import { apiRequest, setAuthErrorHandler } from './apiInterceptor';
import * as questionServiceFunctions from './questionService/index';
import * as navigationService from './navigationService';
import * as answerServiceNew from './answerService';

// Export all services as named exports
export {
  categoryService,
  categoryGroupService,
  examTypeService,
  examService,
  feedbackService,
  savedQuestionsService,
  aiService,
  answerService,
  questionService,
  questionFormatService,
  userFolderService,
  themeService,
  sessionService,
  navigationService
};

/**
 * ExamFlip API Services
 */
const services = {  category: categoryService,
  categoryGroup: categoryGroupService,
  examType: examTypeService,
  exam: examService,
  feedback: feedbackService,
  savedQuestions: savedQuestionsService,
  ai: aiService,
  answer: answerService,
  userFolder: userFolderService,  question: {
    ...questionService,
    getCurrentQuestion: questionServiceFunctions.getCurrentQuestion,
    extractClues: questionServiceFunctions.extractClues,
    getQuestionWithClues: questionServiceFunctions.getQuestionWithClues,
    getExplanationText: questionServiceFunctions.getExplanationText,
    isSelectedAnswerCorrect: questionServiceFunctions.isSelectedAnswerCorrect,
    getCorrectAnswerId: questionServiceFunctions.getCorrectAnswerId,
    validateQuestion: questionServiceFunctions.validateQuestion,
    getQuestionDetails: questionServiceFunctions.getQuestionDetails,
    getQuestionById: questionServiceFunctions.fetchQuestionById,
    fetchQuestionById: questionServiceFunctions.fetchQuestionById,
    fetchQuestionDetailsForSession: questionServiceFunctions.fetchQuestionDetailsForSession,
    getQuestionsCount: questionService.getQuestionsCount
  },
  questionFormat: questionFormatService,
  theme: themeService,
  session: sessionService,
  navigation: navigationService,
  answerService: answerServiceNew,
  auth: authService,
  api: { request: apiRequest, setAuthErrorHandler }
};

export default services;
